import React from "react";
import Tooltip from "react-native-walkthrough-tooltip";
import { AppColors } from "../../../utility/AppColors";
import {
  Image,
  ScrollView,
  Text,
  TouchableHighlight,
  TouchableOpacity,
  View,
} from "react-native";
import ImageComponent from "../../ImageComponent";
import { AppImages } from "../../../utility/AppImages";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { useTooltips } from "../../../context/WalkthroughContext";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Separator from "../../Separator";
import CreateEventComponent from "../../home-common-components/CreateEventComponent";
import { CropImage } from "../../choose-avatar-components/CropImage";
import Avatar from "../../choose-avatar-components/Avatar";

const CreateEventWalkthrough = ({
  isMyEvents,
  setIsMyEvents,
  setShowEventTypeModal,
  userData,
}) => {
  const {
    setCreateEventTooltipVisible,
    setSignupEventTooltipVisible,
    setHomeWalkThroughVisible,
    currentStep,
    totalSteps,
    createEventTooltipVisible,
    handleNextStep,
  } = useTooltips();
  const deviceSize = useDeviceSize();
  return (
    <View
      style={{
        justifyContent: "center",
      }}
    >
      <Tooltip
        isVisible={createEventTooltipVisible}
        contentStyle={{
          backgroundColor: AppColors.purple_453B50,
          width:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 350
              : 736,
          borderColor: AppColors.white,
          shadowColor: "rgba(255, 255, 255, 0.65)",
          shadowOffset: { width: 0, height: 0 },
          shadowOpacity: 0.65,
          shadowRadius: 10.1,
          elevation: 5,
          borderWidth: 1,
        }}
        displayInsets={{
          top:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 125
              : 150,
          bottom: 0,
          left:
            deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
              ? 10
              : deviceSize === DEVICE_SIZES.MD || deviceSize === DEVICE_SIZES.LG
              ? 50
              : 0,
          right: 100,
        }}
        arrowStyle={{ display: "none" }}
        content={
          <ScrollView
            style={{
              ...(deviceSize === DEVICE_SIZES.SM ||
              deviceSize === DEVICE_SIZES.XS
                ? { maxHeight: 500 }
                : deviceSize === DEVICE_SIZES.MD ||
                  deviceSize === DEVICE_SIZES.LG
                ? { maxHeight: 400 }
                : {}),
            }}
            showsHorizontalScrollIndicator={false}
          >
            <View>
              <View
                style={{
                  flexDirection:
                    deviceSize === DEVICE_SIZES.SM ||
                    deviceSize === DEVICE_SIZES.XS
                      ? "column"
                      : "row",
                  gap: 10,
                }}
              >
                {" "}
                <TouchableOpacity
                  onPress={() => {
                    setCreateEventTooltipVisible(false);
                    setHomeWalkThroughVisible(false);
                  }}
                  style={{ position: "absolute", right: 0, top: 0, zIndex: 1 }}
                >
                  <ImageComponent
                    url={AppImages.icCloseWhiteSvg}
                    style={{
                      height: 16,
                      width: 16,
                      resizeMode: "contain",
                    }}
                  />
                </TouchableOpacity>
                <View
                  style={{
                    flexDirection: "row",
                    gap: 10,
                    alignItems:
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                        ? "center"
                        : "flex-start",
                  }}
                >
                  <Avatar
                    src="https://squadify-avatar.s3.eu-west-2.amazonaws.com/tiger.svg"
                    variant="walkthroughPlayer"
                  />
                  {deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM ? (
                    <Text
                      style={[
                        AppFontStyle.BOLD_ANYBODY_12,
                        { color: AppColors.white },
                      ]}
                    >
                      Create an Event ✨
                    </Text>
                  ) : null}
                </View>
                <View
                  style={{
                    flex: 1,
                    marginTop:
                      deviceSize === DEVICE_SIZES.XS ||
                      deviceSize === DEVICE_SIZES.SM
                        ? 0
                        : 12,
                  }}
                >
                  <View style={{ gap: 10 }}>
                    {deviceSize === DEVICE_SIZES.XS ||
                    deviceSize === DEVICE_SIZES.SM ? null : (
                      <Text
                        style={[
                          AppFontStyle.BOLD_ANYBODY_16,
                          { color: AppColors.white }, // Set text color for better readability
                        ]}
                      >
                        Create an Event ✨
                      </Text>
                    )}
                    <View>
                      <Text
                        style={[
                          AppFontStyle.REGULAR_ANYBODY_12,
                          { lineHeight: 21 },
                        ]}
                      >
                        This is where the magic happens—set up an event,
                        challenge rivals, and make your mark.
                      </Text>
                      <View style={{}}>
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            { lineHeight: 21 },
                          ]}
                        >
                          <Text style={{ color: AppColors.green_00FFE8 }}>
                            Choose Event Type:
                          </Text>
                          Pick between a KallOut Event (free and open to all) or
                          an Exclusive Event (private and ticketed for exclusive
                          access).
                        </Text>

                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            { lineHeight: 21 },
                          ]}
                        >
                          <Text style={{ color: AppColors.green_00FFE8 }}>
                            Customise Your Challenge:
                          </Text>
                          Select the game, choose your console, set the date and
                          time, and decide on a wager (coins or belts) to raise
                          the stakes!
                        </Text>

                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            { lineHeight: 21 },
                          ]}
                        >
                          <Text style={{ color: AppColors.green_00FFE8 }}>
                            Add Streaming Options:
                          </Text>
                          Select where to stream—Twitch, YouTube, or KO’s
                          built-in service for Exclusive Events.
                        </Text>

                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_12,
                            { lineHeight: 21 },
                          ]}
                        >
                          <Text style={{ color: AppColors.green_00FFE8 }}>
                            Invite Opponents:
                          </Text>
                          Send out a challenge to friends or share your event
                          link on social media for anyone to join.
                        </Text>
                      </View>
                    </View>

                    {/* event type */}
                    <View style={{ alignItems: "flex-start" }}>
                      <View
                        style={{
                          // width: 335,
                          // height: 235,
                          backgroundColor: AppColors.black_121212,
                          paddingHorizontal: 20,
                          paddingVertical: 20,
                          // margin: 30,
                          // alignSelf: "center",
                        }}
                      >
                        <View style={{ flexDirection: "row" }}>
                          <Text
                            style={[
                              AppFontStyle.BOLD_ANYBODY_20,
                              {
                                flex: 1,
                              },
                            ]}
                          >
                            Event type
                          </Text>
                        </View>
                        <Separator
                          color={AppColors.grayColor_565656}
                          height={2}
                          marginTop={5}
                          marginBottom={0}
                          marginHorizontal={0}
                        />
                        <Text
                          style={[
                            AppFontStyle.REGULAR_ANYBODY_14,

                            { paddingTop: 5, color: AppColors.gray_C3C3C3 },
                          ]}
                        >
                          Select the type of your event
                        </Text>
                        <View
                          style={{
                            marginTop: 10,
                            flexDirection: "row",
                            justifyContent: "flex-start",
                            gap: 20,
                          }}
                        >
                          {/* Private Button */}
                          <View style={{ alignItems: "center" }}>
                            <TouchableOpacity
                              style={[
                                {
                                  borderColor: AppColors.appViolentColor_6D08C3,
                                  flexGrow: 1,
                                  padding: 15,
                                  flex: 1,
                                  flexDirection: "row",
                                  backgroundColor:
                                    AppColors.appBlackColor_1e1e1e,
                                  alignItems: "center",
                                  justifyContent: "flex-start",
                                  gap: 10,
                                  borderWidth: 1,
                                },
                              ]}
                              onPress={() => {}}
                            >
                              <View
                                style={{
                                  height: 7,
                                  width: 7,
                                  borderRadius: 18,
                                  backgroundColor:
                                    AppColors.appViolentColor_6D08C3,
                                  position: "absolute",
                                  top: 5,
                                  left: 7,
                                }}
                              />
                              <Image
                                source={AppImages.icPublic}
                                style={{
                                  height: 100,
                                  width: 100,
                                  resizeMode: "contain",
                                  // margin: 10,
                                }}
                              />
                            </TouchableOpacity>
                            <View>
                              <Text
                                style={[
                                  AppFontStyle.REGULAR_ANYBODY_14,
                                  {
                                    color: AppColors.white,
                                    textAlign: "center",
                                    marginTop: 5,
                                  },
                                ]}
                              >
                                KALL OUT
                              </Text>
                            </View>
                          </View>

                          {/* Public Button */}
                          <View style={{ alignItems: "center" }}>
                            <TouchableOpacity
                              style={{
                                flexGrow: 1,
                                padding: 15,
                                flex: 1,
                                flexDirection: "row",
                                backgroundColor: AppColors.appBlackColor_1e1e1e,
                                alignItems: "center",
                                justifyContent: "flex-start",
                                gap: 10,
                                borderColor: AppColors.appBlackColor_1e1e1e,
                                borderWidth: 1,
                              }}
                              onPress={() => {}}
                            >
                              <View
                                style={{
                                  height: 7,
                                  width: 7,
                                  borderRadius: 18,
                                  borderColor: "#454545",
                                  position: "absolute",
                                  top: 5,
                                  left: 7,
                                  borderWidth: 1,
                                }}
                              />
                              <Image
                                source={AppImages.icPrivate}
                                style={{
                                  height: 100,
                                  width: 100,
                                  resizeMode: "contain",
                                  // margin: 10,
                                }}
                              />
                            </TouchableOpacity>
                            <View>
                              <Text
                                style={[
                                  AppFontStyle.REGULAR_ANYBODY_14,
                                  {
                                    color: AppColors.white,
                                    textAlign: "center",
                                    marginTop: 5,
                                  },
                                ]}
                              >
                                EXCLUSIVE
                              </Text>
                            </View>
                          </View>
                        </View>
                      </View>
                    </View>
                  </View>
                </View>
              </View>
              <View
                style={{
                  gap: 10,
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  marginTop: 10,
                }}
              >
                <Text
                  style={{
                    ...AppFontStyle.REGULAR_ANYBODY_12,
                    color: AppColors.green_00FFE8,
                  }}
                >
                  {currentStep + 1} / {totalSteps}
                </Text>

                <TouchableOpacity
                  onPress={() => {
                    setCreateEventTooltipVisible(false);
                    setSignupEventTooltipVisible(true);
                    handleNextStep();
                  }}
                  style={{
                    backgroundColor: AppColors.appViolentColor_6D08C3,
                    width: 70,
                    height: 20,
                    alignItems: "center",
                    justifyContent: "center",
                    borderRadius: 10,
                    cursor: "pointer",
                    shadowColor: "rgba(0, 0, 0, 0.25)",
                    shadowOffset: { width: 0, height: 4 },
                    shadowOpacity: 0.25,
                    shadowRadius: 4,
                    elevation: 4,
                  }}
                >
                  <Text style={AppFontStyle.BOLD_ANYBODY_12}>Next</Text>
                </TouchableOpacity>
              </View>
            </View>
          </ScrollView>
        }
      >
        <TouchableHighlight>
          <CreateEventComponent
            isMyEvents={isMyEvents}
            setIsMyEvents={setIsMyEvents}
            setShowEventTypeModal={setShowEventTypeModal}
            userData={userData}
          />
        </TouchableHighlight>
      </Tooltip>
    </View>
  );
};

export default CreateEventWalkthrough;
